import React from 'react';
import Tree from './node/tree';
import Path from '../path/path';
import pathStore from '../../store/pathStore';
import { getPaths, redrawPath } from '../../action/pathAction';
import { getTree } from '../../action/treeAction';
import treeStore from '../../store/treeStore';
import ParentModal from './node/modal';
import TitleChanger from './treeHeader/TitleChanger';
import tableStore from '../../store/tableStore';
import PageHoc from '../../HoC/PageHoC';
import userStore from '../../store/userStore';


/**Main container component for the tree */
class TreeContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            path: [],
            show: false,
            parent: 0,
            showTitle: true,
            title: tableStore.table.tableName,
        };
    }

    componentWillMount() {
        treeStore.on("Tree-Changes", this.treeSetter);
        // pathStore.on("Relationship-Changes", this.treeSetter);
        pathStore.on("Path-Changes", this.pathSetter);
        getTree();
        this.setState({
            readOnly: userStore.user.stage >= 2 ? true : false,
            // sourcesAllowed: userStore.user.stage === 2 ? true : false
            sourcesAllowed: true
        });

    }
    componentDidMount() {
        redrawPath();
        getPaths(this.state);
        window.addEventListener("resize", this.redraw);
    }
    componentWillUnmount() {
        window.addEventListener("resize", null);
        pathStore.removeListener("Path-Changes", this.pathSetter);
        treeStore.removeListener("Tree-Changes", this.treeSetter);

        // getPublishedTrees();
    }
    /**Sets the path, but not sure why i set an empty state first
     * The redraw rebuilds the line
     */
    pathSetter = () => {
        // this.setState({ path: [] }, function () {
        this.setState({
            path: pathStore.path
        }, function () {
            redrawPath();
        });
        // });
    };

    treeSetter = () => {
        let tree = [];
        for(let [key,value] of Object.entries(treeStore.tree)){
            if(value.parent === "0"){
                tree.push(value);
            }
        }
        this.setState({
            treeLevelOne: tree
        });
    };

    redraw = () => {
        redrawPath();
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    modalOpener = (entity) => {
        this.setState({ show: true });
        this.setState({ parent: entity });
    };

    render() {
        return (
            <div>
                <div id="container" style={{ top: "12vh" }}>
                    <div className="logged-in">
                        <Path path={this.state.path} />
                        <TitleChanger />
                        <Tree addEvent={this.modalOpener} tree={this.state.treeLevelOne} readOnly={this.state.readOnly} />
                        <ParentModal show={this.state.show} parent={this.state.parent} hide={this.hideModal}
                            readOnly={this.state.readOnly} sourcesAllowed={this.state.sourcesAllowed} />
                    </div>
                </div>
            </div>
        );
    }
}
export default PageHoc(TreeContainer);


// WEBPACK FOOTER //
// ./src/components/tree/TreeContainer.js